import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { saFetch, SALoading, fmtDateTime, btnOutline } from "./saCommon";
import { Button } from "@/components/ui/button";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export default function SAAuditoria() {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);

  const load = useCallback(() => {
    saFetch(`/superadmin/audit?page=${page}&per_page=30`).then(setData).catch((e) => toast.error(e.message));
  }, [page]);
  useEffect(load, [load]);

  if (!data) return <SALoading label="Cargando historial..." />;

  const totalPages = Math.max(1, Math.ceil(data.total / data.per_page));

  return (
    <div data-testid="sa-auditoria">
      <div className="mb-6">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-foreground">Historial de cambios</h1>
        <p className="text-sm text-muted-foreground mt-1">{data.total} acción(es) registradas en la plataforma</p>
      </div>

      {data.items.length === 0 ? (
        <div className="border border-border rounded-sm p-10 text-center text-muted-foreground bg-card" data-testid="sa-audit-empty">
          Aún no hay actividad registrada.
        </div>
      ) : (
        <div className="border border-border rounded-sm bg-card divide-y divide-border" data-testid="sa-audit-list">
          {data.items.map((a) => (
            <div key={a.id} className="flex items-start justify-between gap-4 p-3.5 hover:bg-muted/50 transition-colors duration-200" data-testid={`sa-audit-${a.id}`}>
              <div className="min-w-0">
                <p className="text-sm text-foreground">{a.detail}</p>
                <p className="text-[11px] text-muted-foreground mt-0.5">
                  <span className="text-primary/80 font-mono">{a.action}</span>
                  {" · "}{a.actor}{a.tenant_id ? ` · empresa ${a.tenant_id.slice(0, 8)}` : ""}
                </p>
              </div>
              <span className="text-xs text-muted-foreground shrink-0">{fmtDateTime(a.created_at)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="flex items-center justify-between mt-3">
        <span className="text-xs text-muted-foreground">Página {data.page} de {totalPages}</span>
        <div className="flex gap-2">
          <Button variant="outline" size="icon" className={btnOutline} disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="sa-audit-prev"><CaretLeft size={15} /></Button>
          <Button variant="outline" size="icon" className={btnOutline} disabled={page >= totalPages} onClick={() => setPage(page + 1)} data-testid="sa-audit-next"><CaretRight size={15} /></Button>
        </div>
      </div>
    </div>
  );
}
